'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _subsectionReducers = require('./subsection-reducers');

var _subsectionReducers2 = _interopRequireDefault(_subsectionReducers);

var _mainReducers = require('./main-reducers');

var _mainReducers2 = _interopRequireDefault(_mainReducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coreNavigationUI = (0, _redux.combineReducers)({
    subsections: _subsectionReducers2.default,
    main: _mainReducers2.default
});

exports.default = coreNavigationUI;
//# sourceMappingURL=reducers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/core-navigation-ui/reducers.js
 ** module id = 625
 ** module chunks = 1
 **/